/**
 * @param {jQuery} $
 * @param {AppConfig} config
 * @param {AppLibrary} library
 * @param {Customer} customerObj
 * @param {Tabs} tabs
 * @constructor
 */
export let CustomerAccount = function ($, config, library, customerObj, tabs) {
  /**
   * @type {string}
   */
  let content = `
<div class="slp-content">
    <div data-spurit-slp-customer-account="content"></div>
</div>`;

  /**
   * @type {{root: string, content: string}}
   */
  const selectors = {
    root: '[data-spurit-slp-customer-account="root"]',
    content: '[data-spurit-slp-customer-account="content"]'
  };

  /**
   * @type {HTMLElement}
   */
  let rootElement, tabContent;

  /**
   *
   */
  let init = () => {
    if (config.getCustomer().id) {
      rootElement = document.querySelector(selectors.root);
      rootElement.innerHTML = library.mustache().render(
        config.customization().customerAccountHeader || content,
        {}
      );
      tabContent = rootElement.querySelector(selectors.content);
      tabs.render(tabContent, ['history', 'info', 'terms']);
    }
  };

  init();
};
